export function useTextFormatter () {
    function formatText (input: string): string {
        return input
            .toLowerCase()
            .split(' ')
            .map((word) => {
                if (/^[a-z]{2}$/.test(word)) {
                    return word.toUpperCase()
                }

                return word.charAt(0).toUpperCase() + word.slice(1)
            })
            .join(' ')
    }

    function middleEllipsis (text: string, maxLength = 10) {
        if (text.length <= maxLength) { return text }

        const half = Math.floor(maxLength / 2)
        const left = text.slice(0, half).trim()
        const right = text.slice(text.length - half).trim()

        return left + '...' + right
    }

    function formatRupiah (value?: number | string | null) {
        if (value == null) { return 0 }

        return new Intl.NumberFormat('id-ID', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(Number(value))
    }

    return {
        formatText,
        middleEllipsis,
        formatRupiah,
    }
}
